import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { BsTrash } from "react-icons/bs";

const MaterialRow = ({ value, onChange, materialOptions, onDelete }) => {
  function deleteHandler() {
    if (window.confirm("Are you sure you want to delete this material?")) {
      onDelete();
    }
  }

  return (
    <tr>
      <td>
        <div className="flex space-x-2 items-center">
          <Button danger onClick={deleteHandler}>
            <BsTrash />
          </Button>
          <Select
            value={value.materialId}
            onChange={(e) => {
              onChange({ materialId: e.target.value });
            }}
          >
            <option value={0} disabled>
              Select Material
            </option>
            {materialOptions.map((i) => (
              <option key={i.id} value={i.id}>
                {i.name}
              </option>
            ))}
          </Select>
        </div>
      </td>
      <td>
        <Input
          className="text-right w-24"
          value={value.weight}
          onChange={(e) => {
            onChange({ weight: e.target.value });
          }}
        />
      </td>
      <td className="w-full">
        <Input
          className="w-full"
          placeholder="Remark, for example position."
          value={value.remark}
          onChange={(e) => {
            onChange({ remark: e.target.value });
          }}
        />
      </td>
    </tr>
  );
};

export default MaterialRow;
